import moment from 'moment'

import { uiConstants } from '../constants'

const currentTime = () => {
  return moment().utc().unix()
}

const startDayToday = () => {
  return moment().utc().startOf('day').unix()
}

const timeToDate = (d, empty = '-') => {
  if (d === 0) {
    return empty
  }
  return moment.unix(d).format(uiConstants.dateFormat)
}

const timeToDateTime = (d, empty = '-') => {
  if (d === 0) {
    return empty
  }
  return moment.unix(d).format(uiConstants.dateTimeFormat)
}

const timeToDateInput = (d) => {
  return moment.unix(d).format(uiConstants.timeToDateInput)
}

const dateInputToTime = (d) => {
  return moment.utc(d).startOf('day').unix()
}

const timeToHour = (d) => {
  return moment.unix(d).utc().format(uiConstants.hourFormat)
}

const getHours = (start, end) => {
  return (end - start) / 3600 + 'H'
}

const dayOfWeekFromTime = (d) => {
  switch (moment.unix(d).utc().day()) {
    case 1:
      return 'lunedì'
    case 2:
      return 'martedì'
    case 3:
      return 'mercoledì'
    case 4:
      return 'giovedì'
    case 5:
      return 'venerdì'
    case 6:
      return 'sabato'
    default:
      return 'domenica'
  }
}

const timeToInputTime = (d) => {
  const sd = moment.unix(d).startOf('day').utc().unix()
  const time = d - sd
  const hour = Math.floor(time / 3600)
  const min = time % 60
  return `${hour < 10 ? '0' : ''}${hour}:${min}${min < 10 ? '0' : ''}:00`
}

const dateHourInputToTime = (date, time) => {
  const startOfDay = dateInputToTime(date)
  const t = time.split(':')
  const h = parseInt(t[0]) * 3600
  const m = parseInt(t[1]) * 60
  return startOfDay + h + m
}

export const timeHelper = {
  currentTime,
  startDayToday,
  timeToDate,
  timeToDateTime,
  timeToHour,
  getHours,
  dayOfWeekFromTime,
  timeToDateInput,
  dateInputToTime,
  timeToInputTime,
  dateHourInputToTime
}
